import { Object } from 'fabric/fabric-impl';
import { ArrowDown, ArrowUp, MoveDown, MoveUp } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';
import layerManager from 'ud-ui/components/fabric-canvas/addons/layer-manager';
import { selectFabricManager } from '../../../../../store/editor/selectors';
import { Button, Item } from '../styles';

interface LayerControlsProps {
  object?: Object;
  useActiveObject?: boolean;
}

const LayerControls: React.FC<LayerControlsProps> = ({ object, useActiveObject }) => {
  const fabricManager = useSelector(selectFabricManager);

  const handleLayerAction = (action: 'front' | 'back' | 'forward' | 'backward') => {
    const targetObject = useActiveObject ? (fabricManager?.canvas.getActiveObject() as Object) : object;
    if (!targetObject) return;

    if (action === 'front') {
      layerManager.sendToFront(targetObject);
    } else if (action === 'back') {
      layerManager.sendToBack(targetObject);
    } else if (action === 'forward') {
      layerManager.sendForward(targetObject);
    } else {
      layerManager.sendBackward(targetObject);
    }
  };

  return (
    <Item>
      Слои
      <Button onClick={() => handleLayerAction('front')} icon={<MoveUp size={16} color={'#929292'} />}>
        Поднять вверх
      </Button>
      <Button onClick={() => handleLayerAction('forward')} icon={<ArrowUp size={16} color={'#929292'} />}>
        На 1 слой вверх
      </Button>
      <Button onClick={() => handleLayerAction('backward')} icon={<ArrowDown size={16} color={'#929292'} />}>
        На 1 слой вниз
      </Button>
      <Button onClick={() => handleLayerAction('back')} icon={<MoveDown size={16} color={'#929292'} />}>
        Переместить вниз
      </Button>
    </Item>
  );
};

export default LayerControls;
